import { Button } from '@clay-run/glaze/button';
import { Icon } from '@clay-run/glaze/icon';
import { Text } from '@clay-run/glaze/text';
import type { AccountHierarchyNode } from '@shared/flow/account-hierarchy';
import { whitespaceStatusOf } from '@shared/flow/account-hierarchy-whitespace';
import { nodeActionItems, type HierarchyNodeFacts } from './HierarchyNodeMenu';
import { DASH, WHITESPACE_LABEL } from './hierarchyPresentation';

export interface SelectedAccountCardProps {
  node: AccountHierarchyNode;
  facts: HierarchyNodeFacts;
}

/**
 * Full screen only: the selected account's name, owner and customer status with the same actions
 * as its "..." menu, as plain buttons, so they are discoverable without hovering or opening a menu.
 */
export function SelectedAccountCard({ node, facts }: SelectedAccountCardProps) {
  return (
    <div
      role="region"
      aria-label="Selected account"
      data-testid="hierarchy-selected-account"
      className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-border-primary bg-bg-primary px-3 py-2"
    >
      <div className="flex min-w-0 flex-col">
        <span className="text-xs text-content-tertiary">Selected account</span>
        <Text size="sm" weight="medium" variant="primary" className="truncate">{node.name ?? node.id}</Text>
      </div>
      <Text size="xs" variant="secondary">{`Owner: ${node.owner_name ?? DASH}`}</Text>
      <Text size="xs" variant="secondary">{`Status: ${WHITESPACE_LABEL[whitespaceStatusOf(node)]}`}</Text>
      <span className="ml-auto flex flex-wrap items-center gap-1">
        {nodeActionItems(facts).map(item => (
          <Button key={item.key} type="button" size="sm" variant="secondary" disabled={item.disabled} onClick={item.run}>
            <Icon type={item.icon} size="sm" aria-hidden />
            {item.label}
          </Button>
        ))}
      </span>
    </div>
  );
}
